import { openNewTab } from '../../helpers';

export default function eventTitleLink() {
  const widgetName = 'eventTitleLink';
  const widgetOpts = eventTitleLinkOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        $('#animatedMetrics').remove();
        customeventTitleLink(data);
      } else {
        $widget.remove();
      }
    },
  });

  function customeventTitleLink(widgetData) {
    const { Title, URL, Description } = widgetData.items[0];

    $widget.find('.card-widget-item').replaceWith(
      `
      <h2 class="event-title">${Description}</h2>
      ${URL == null ? '' : `<a class="button" tabindex="0" href="${URL}" ${openNewTab(URL)}>${Title}</a>`}
      `,
    );
  }
}
